import { useChoiceState } from '@context/ChoiceContext'

export const useHasUserSelectedSlot = (): boolean => {
  const { selectedBookableDateAndTime } = useChoiceState()

  return Boolean(selectedBookableDateAndTime?.originalStartTimestamp)
}
